import { GlobalExportButton } from './global-export-button'
import { ReportingSessionSwitcher } from './reporting-session-switcher'
import { ReportingTeamSwitcher } from './reporting-team-switcher'
import { SessionWholeExport } from './session-whole-export'

// Reporting-specific controls injected between the shared nav items and the
// nav user menu. Layout (left → right): Export | Session | Team. The user
// menu is overridden via AppConfig.topnavUser and rendered by the shared
// TopNavLayout, not here.
//
// <SessionWholeExport/> sits inside this fragment so the "Entire session
// (pdf)" Export action has a consistent mount point across all routes. It
// renders nothing until the flag flips.
export function ReportingTopnavExtra() {
  return (
    <div className='flex items-center gap-2'>
      <GlobalExportButton />
      <ReportingSessionSwitcher />
      <ReportingTeamSwitcher />
      <SessionWholeExport />
    </div>
  )
}
